// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".planEditor-div[data-v-1d8ecde5]{padding:0 20px}.planEditor-div .plan-form[data-v-1d8ecde5]{border-bottom:1px solid #e0e0e0}.planEditor-div .save-div[data-v-1d8ecde5]{padding:20px;text-align:center}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
